// extracted by mini-css-extract-plugin
export default {"content":"UserGoal_content__Mb8f2","content2":"UserGoal_content2__2CysV","spacing":"UserGoal_spacing__mbBeO"};